import { render, staticRenderFns } from "./InvalidFormDialog.vue?vue&type=template&id=1bd25ddf&"
import script from "./InvalidFormDialog.vue?vue&type=script&lang=js&"
export * from "./InvalidFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports